import * as React from 'react';
import * as Dictionary from 'Models/Dictionary';
import {WrappedFieldProps} from 'redux-form';
import * as VehiclesModule from 'Modules/VehiclesModule';
import {withTranslation} from 'react-i18next';
import {Link} from "react-router-dom";
import { EnumTypes as PageEnumTypes } from 'Models/EnumTypes/PageEnumTypes'

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    options: Array<VehiclesModule.Types.CarDto>;
    t?: Function;
    onDelete: Function;
    showList: () => void;
};

class CarIdsSelect extends React.PureComponent<WrappedFieldProps & Props> {
    public handleClick(value) {
        // if (this.props.disabled) {
        //     return null;
        // } else {
        //     this.props.input.onChange(value);
        // }
    }

    public handleDelete(car: VehiclesModule.Types.CarDto) {
        this.props.onDelete(car);
    }

    public render() {
        const {input, meta, label, disabled, t, showList} = this.props;
        return (
            <div className="assign">
                <label htmlFor={input.name} className="form-field__label">{label}</label>
                <div className="assign__control">
                    <div className="assign-item__image-wrapper"/>
                    <div className="assign-item__title-1">
                        <img src="/images/icons/car.svg" width="15" alt="" className="mr-10"/>
                        <span>{t('carNo')}</span>
                    </div>
                    <div className="assign-item__title-2">
                        <span>{t('name')}</span>
                    </div>
                    <div className="assign-item__delete"/>
                </div>
                {Array.isArray(input.value) && input.value.length > 0 &&
                <div className="form-field form-field--expand mt-10">
                    {
                        input.value.map((car: VehiclesModule.Types.CarDto, idx) => {
                            return (
                                <Link
                                  key={`${car}-${idx}`}
                                  className="assign-item assign-item--border assign-item__link"
                                     // onClick={() => this.handleClick(element.id)}
                                  to={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/${car.id}/diagnostic`}
                                >
                                    <div className="assign-item__image-wrapper">
                                        <img src={Dictionary.CarCategoryTableFilters.get(car.carCategory)}
                                             alt=""
                                             className="assign-item__img"/>
                                    </div>
                                    <div className="assign-item__title-1">
                                        {car.vin} [{car.deviceId}]
                                    </div>
                                    <div className="assign-item__title-2">{car.name || car.model} </div>
                                    <div className="assign-item__delete">
                                        <i className="icon--plus_sign rotate-45deg"
                                           onClick={(event) => {
                                              event.preventDefault()
                                             this.handleDelete(car)
                                           }}/>
                                    </div>
                                </Link>
                            );
                        })
                    }
                </div>
                }
                {(meta.touched &&
                    (meta.error && (
                        <div className="form_field--error_wrapper">
                            <span className="form_field--error">{meta.error}</span>
                        </div>
                    ))) ||
                (meta.warning && <span>{meta.warning}</span>)}

                <p className="flex flex--center mt-10 font-xmd">
                    <span className="mr-7">{t('addCar')}</span>
                    <i className="icon--plus_sign" onClick={showList}/>
                </p>
            </div>
        );
    }
}

export default withTranslation(['forms', 'errors', 'carDetails'])(CarIdsSelect as React.ComponentType<any>) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/CarIdsSelect.tsx